import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import { Loader } from 'components';

/**
 * @param {import('react').ButtonHTMLAttributes<HTMLButtonElement> & {
 *  innerRef?: React.RefObject<HTMLButtonElement>
 *  variant?: import('utils/types').ButtonVariant
 *  size: import('utils/types').SizeVariant
 *  spinnerSize: import('utils/types').SizeVariant
 *  disabled?: boolean
 *  processing?: boolean
 *  processingText?: string
 *  className?: string
 * }} props
 */
export default function Button({
  innerRef = null,
  variant = 'primary',
  size = 'md',
  spinnerSize = 'md',
  disabled = false,
  processing = false,
  processingText = '',
  className = '',
  children = null,
  ...htmlProps
}) {
  return (
    <button
      {...htmlProps}
      ref={innerRef}
      disabled={disabled || processing}
      data-processing={!!processing}
      className={cn(
        styles.button,
        styles[variant],
        styles[`size-${size}`],
        className
      )}
    >
      <div className={styles.cell}>{children}</div>
      <div className={styles.cell}>
        {processingText}
        <span className={styles.loader}>
          <Loader.Spinner size={spinnerSize} />
        </span>
      </div>
    </button>
  );
}
